import { render, staticRenderFns } from "./checkbox-column.vue?vue&type=template&id=62e65d3c&"
import script from "./checkbox-column.vue?vue&type=script&lang=js&"
export * from "./checkbox-column.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-column.vue?vue&type=style&index=0&id=62e65d3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports